import { Grid } from '@mui/material';

import { ScoreType, Sector } from '@/domain/impact/impact.entity';
import {
  selectImpactCalculateVenueCo2ForProject,
  selectImpactCalculateVenueEnvForProject,
  selectImpactCalculateVenueEssForProject,
} from '@/domain/impact-calculate-venue/impact-calculate-venue.selectors';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { scrollQuizPanelToId } from '@/ui/components/quiz-panel/QuizPanel.utils.ts';
import { useAppSelector } from '@/ui/hook/store';
import { TopicScoreAndDetailsCard } from '@/ui/pages/app/components/topic-score-card/TopicScoreAndDetailsCard';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';

import { prepareVenueTopicScoreDetailsDataCo2 } from '../utils/prepare-topic-score-details-data/co2';
import { prepareVenueTopicScoreDetailsDataEnv } from '../utils/prepare-topic-score-details-data/env';
import { prepareVenueTopicScoreDetailsDataEss } from '../utils/prepare-topic-score-details-data/ess';

export function VenueStructureMainContent({
  setSelectedTopic,
  setSelectedSector,
  setSelectedDetailsValueId,
}: {
  setSelectedTopic: (scoreType: ScoreType) => void;
  setSelectedSector: (selectedSector: Sector) => void;
  setSelectedDetailsValueId: (electedDetailsValueId: string) => void;
}) {
  const project = useAppSelector(selectCurrentProjectVenue);

  const calculateVenueCo2 = useAppSelector(
    selectImpactCalculateVenueCo2ForProject(project?.id || -1),
  );
  const calculateVenueEnv = useAppSelector(
    selectImpactCalculateVenueEnvForProject(project?.id || -1),
  );
  const calculateVenueEss = useAppSelector(
    selectImpactCalculateVenueEssForProject(project?.id || -1),
  );

  const co2Data: TopicScoreDetailsData =
    prepareVenueTopicScoreDetailsDataCo2(calculateVenueCo2);
  const envData: TopicScoreDetailsData =
    prepareVenueTopicScoreDetailsDataEnv(calculateVenueEnv);
  const essData: TopicScoreDetailsData =
    prepareVenueTopicScoreDetailsDataEss(calculateVenueEss);

  const onClickDetailsItem = (type: ScoreType, id: string, sector?: Sector) => {
    setSelectedTopic(type);
    const idSplitted = id.split('-');
    if (idSplitted[0]) {
      setSelectedDetailsValueId(idSplitted[0]);
    }
    if (idSplitted[1]) {
      scrollQuizPanelToId(`#${idSplitted[1].toLowerCase()}-form`);
    }
    if (sector) {
      setSelectedSector(sector);
    }
  };

  const onClickAnswerAll = (type: ScoreType) => {
    setSelectedTopic(type);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <TopicScoreAndDetailsCard
          type={'co2'}
          data={co2Data}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TopicScoreAndDetailsCard
          type="env"
          data={envData}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TopicScoreAndDetailsCard
          type={'ess'}
          data={essData}
          onClickDetailsItem={onClickDetailsItem}
          onClickAnswerAll={onClickAnswerAll}
        />
      </Grid>
    </Grid>
  );
}
